module.exports = __webpack_public_path__ + "img/DE05837.4ffc3d63.svg";